<template>
  <div class="animated fadeIn">
    <!-- Loading fade-in -->
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" />
    <!-- START /indicators -->
    <b-row>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <b-dropdown class="float-right" variant="transparent p-0" right no-caret>
              <template slot="button-content">
                <i class="fa fa-plus-square" style="font-size:24px;"></i>
              </template>
              <b-dropdown-item @click="enviarpush">Enviar push</b-dropdown-item>
              <b-dropdown-item @click="visualizarclientes">Visualizar clientes</b-dropdown-item>
            </b-dropdown>
            <h4 class="mb-0">{{ clientesCadastrados }}</h4>
            <p>Clientes cadastrados</p>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-info">
          <b-card-body class="pb-0">
            <b-dropdown class="float-right" variant="transparent p-0" right no-caret>
              <template slot="button-content">
                <i class="fa fa-plus-square" style="font-size:24px;"></i>
              </template>
              <b-dropdown-item @click="enviarpush">Visualizar envios</b-dropdown-item>
              <b-dropdown-item @click="comprarpacotes">Comprar pacotes</b-dropdown-item>
            </b-dropdown>
            <h4 class="mb-0">{{ pushsEnviados }}</h4>
            <p>Pushs enviados</p>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-success">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{ sorteiosAtivos }}</h4>
            <p>Sorteios ativos</p>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-danger">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{ promocoesAtivas }}</h4>
            <p>Promoções ativas</p>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <!-- END /indicators -->
    <!-- START /filter -->
    <b-row>
      <b-col cols="12">
        <b-card no-body class="mt-2">
          <b-tabs pills card>
            <b-tab title="Filtros">
              <b-row>
                <b-col xl="4" lg="4" md="4" sm="12">
                  <b-input-group prepend="Data Inicial" class="date-input">
                    <datepicker
                      class="form-control"
                      placeholder="Escolha a data"
                      v-model="datainicial"
                      :language="ptBR"
                      :format="customFormatter"
                      :disabledDates="disabledDatesStart"
                      :key="disabledDatesStart != null"
                      @selected="mudaDataInicial"
                    ></datepicker>
                  </b-input-group>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12">
                  <b-input-group prepend="Data Final" class="date-input">
                    <datepicker
                      class="form-control"
                      placeholder="Escolha a data"
                      v-model="datafinal"
                      :language="ptBR"
                      :format="customFormatter"
                      @selected="mudaDataFinal"
                      :disabledDates="disabledDatesEnd"
                      :key="disabledDatesEnd != null"
                    ></datepicker>
                  </b-input-group>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12">
                  <b-button @click="gerarAnalise" variant="primary" class="m-w">Gerar análise</b-button>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
    <!-- END /indicators -->
    <!-- START /interesses -->
    <b-row>
      <b-col xl="6" lg="6" md="12" sm="12">
        <b-card header="Clientes por interesse" class="mt-2">
          <clientes-por-interesse></clientes-por-interesse>
        </b-card>
      </b-col>
      <b-col xl="6" lg="6" md="12" sm="12">
        <b-card class="mt-2">
          <template
            slot="header"
          >Detalhamento por caixa - {{moment(datainicial).format('DD/MM/YY')}} a {{moment(datafinal).format('DD/MM/YY')}}</template>
          <ticket-medio-por-caixa :datainicial="datainicial" :datafinal="datafinal"></ticket-medio-por-caixa>
        </b-card>
      </b-col>
    </b-row>
    <!-- END /interesses -->
    <!-- START /payment -->
    <b-row>
      <b-col xl="12" lg="12" md="12" sm="12">
        <b-card class="mt-2">
          <template
            slot="header"
          >Formas de pagamento mais utilizadas - {{moment(datainicial).format('DD/MM/YY')}} a {{moment(datafinal).format('DD/MM/YY')}}</template>
          <formas-de-pagamento :datainicial="datainicial" :datafinal="datafinal"></formas-de-pagamento>
        </b-card>
      </b-col>
    </b-row>
    <!-- END /payment -->
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { ptBR } from "vuejs-datepicker/dist/locale";
import ClientesPorInteresse from "./charts/ClientesPorInteresse";
import TicketMedioPorCaixa from "./charts/TicketMedioPorCaixa";
import FormasDePagamento from "./charts/FormasDePagamento";
import axios from "axios";
import Loading from "vue-loading-overlay";

import * as config from "@/config.json";
import moment from "moment";

export default {
  name: "dashboard",
  components: {
    Datepicker,
    ClientesPorInteresse,
    TicketMedioPorCaixa,
    FormasDePagamento,
    Loading,
    moment
  },
  data: function() {
    return {
      selected: "Month",
      clientesCadastrados: null,
      pushsEnviados: null,
      promocoesAtivas: null,
      sorteiosAtivos: null,
      isLoading: false,
      datainicial: null,
      datafinal: null,
      ptBR: ptBR,
      disabledDatesStart: null,
      disabledDatesEnd: null
    };
  },
  methods: {
    enviarpush() {
      this.$router.push("/campanhas/");
    },
    visualizarclientes() {
      this.$router.push("/clientes");
    },
    comprarpacotes() {
      this.$router.push("/pacotes");
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    gerarAnalise() {
      axios
        .get(
          `${
            config.default.servidor
          }/gerencial/checa-campanhas/${localStorage.getItem(
            "enterprise_id"
          )}/${this.datainicial}/${this.datafinal}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.status == 200)
            if (response.data)
              if (!response.data.error && response.data.campanhas) {
                localStorage.setItem("datainicial", this.datainicial);
                localStorage.setItem("datafinal", this.datafinal);
                localStorage.setItem("qtdCampanhas", response.data.qtd);
                this.$router.push({ path: "analise" });
              } else {
                const options = { title: "Erro", size: "sm" };
                this.$dialogs
                  .alert(
                    `Não foi encontrada nenhuma campanha no período selecionado. Data Inicial: ${moment(
                      this.datainicial
                    ).format("DD/MM/YYYY")}.
                    \nData Final: ${moment(this.datafinal).format(
                      "DD/MM/YYYY"
                    )}.`,
                    options
                  )
                  .then(res2 => {});
              }
        });
    },
    mudaDataFinal(data) {
      if (data) {
        this.disabledDatesStart = null;
        this.disabledDatesStart = {};
        this.disabledDatesStart.from = new Date(data);
      }
    },
    mudaDataInicial(data) {
      if (data) {
        this.disabledDatesEnd = null;
        this.disabledDatesEnd = {};
        this.disabledDatesEnd.to = new Date(data);
      }
    }
  },
  beforeMount() {
    localStorage.removeItem("datainicial");
    localStorage.removeItem("datafinal");
    localStorage.removeItem("qtdCampanhas");
    this.isLoading = true;
    this.datainicial = moment()
      .startOf("month")
      .format("YYYY-MM-DD hh:mm");
    this.datafinal = new moment()
      .add(1, "months")
      .date(1)
      .format("YYYY-MM-DD hh:mm");
    this.disabledDatesStart = {};
    this.disabledDatesStart.from = new Date(this.datafinal);

    this.disabledDatesEnd = {};
    this.disabledDatesEnd.to = new Date(this.datainicial);
    axios
      .get(
        `${
          config.default.servidor
        }/gerencial/retorna-totalizadores/${localStorage
          .getItem("enterprise_id")
          .toString()}`,
        {
          headers: {
            Authorization: "Basic c2E6QURNQUNDRVNZUw=="
          }
        }
      )
      .then(response => {
        this.clientesCadastrados = response.data.data.qtdRegistrados;
        this.pushsEnviados = response.data.data.qtdPushs;
        this.promocoesAtivas = response.data.data.qtdPromocoesAtivas;
        this.sorteiosAtivos = response.data.data.qtdSorteiosAtivos;
        this.isLoading = false;
      })
      .catch(error => {
        console.error(error);
        this.isLoading = false;
      });
  }
};
</script>